const parentWindow = window.parent;

export const onMsg = (msg: string | object, trustedOrigin: string) => {
  parentWindow.postMessage(
    JSON.stringify({
      message: msg
    }),
    trustedOrigin
  );
};
